import { Card, Col, Row } from 'antd';
import React from 'react'
import AdditionalIncome from '../AdditionalIncome';
import EmployeeDetails from '../EmployeeDetails';

function Income() {
  return (
    <Card title="Income" className='income'>
      <Row gutter={[0, 8]}>
        <Col span={24}>
            <EmployeeDetails />
        </Col>
        <Col span={24}>
            <AdditionalIncome />
        </Col>
      </Row>
    </Card>
  )
}

export default Income;
